export let LoginView = /*#__PURE__*/function (LoginView) {
  LoginView[LoginView["LOGIN_FORM"] = 0] = "LOGIN_FORM";
  LoginView[LoginView["RESTORE_PASS_FORM"] = 1] = "RESTORE_PASS_FORM";
  return LoginView;
}({});
export let LoginActionStatus = /*#__PURE__*/function (LoginActionStatus) {
  LoginActionStatus["SUCCESS"] = "SUCCESS";
  LoginActionStatus["ERROR"] = "ERROR";
  return LoginActionStatus;
}({});